import { BaseTicketController } from '../../../../common/base/ticketController';

export class AuthorizationReceivingController extends BaseTicketController {
  constructor(controllerService, TicketStates, ticketService) {
    'ngInject';
    super({ controllerService, TicketStates, ticketService });

    // NOTE this.ticket is resolved from ticket.state (parent view)
  }

  $onInit() {
    super.$onInit();
  }

  submit() {
    const { ticket, ticketService } = this;
    return ticketService.initializationConfirmation(ticket.id);
  }

  reject(reasons) {
    return this.ticketService.rejectSignedWarrant(this.ticket.id, reasons);
  }
}
